import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Edit3, Eye, Trash2, User } from 'react-feather';
import IconButton from '@mui/material/IconButton';
import '../../styles/table.css'; // Importing the external CSS
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PlusCircle } from 'react-feather';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logout } from '../../features/auth/AuthSlice';


export default function UserRoll({ apiResponse }) {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [roleId, setRoleId] = useState('')
  const [filteredRows, setFilteredRows] = useState([]); // Store filtered data

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    if (apiResponse?.data?.actions?.list) {
      fetchRole()
    }
  }, [])

  const handleClickEdit = (id) => {
    navigate('/editrole', { state: { roleId: id } });
  };
  const handleClickView = (id) => {
    navigate('/viewrole', { state: { roleId: id } });
  };

  const columns = [
    {
      field: 'role_name',
      headerName: 'User Role',
      flex: 0.5,
      renderCell: (params) => (
        <a href="#" className="location-link">
          {params.value}
        </a>
      ),
    },
    {
      field: 'no_of_enrolled',
      headerName: 'No.Enrolled',
      flex: 0.5,
    },
    {
      field: 'permissions',
      headerName: 'Module Access',
      flex: 1,
      valueGetter: (params) => {
        return params?.map((perm) => perm.module_name).join(', ');
      },
    },
    {
      field: "created_at",
      headerName: "Created Date",
      flex: 0.5,
      renderCell: (params) => {
        const date = params.value ? new Date(params.value) : null;
        return <p>{date ? date.toLocaleDateString("en-US") : ""}</p>;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.5,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status == 1 ? 'Active' : 'Inactive'}
          </div>
        );
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.8,
      renderCell: (params) => (
        <>
          {apiResponse?.data?.actions?.view && (
            <IconButton
              onClick={() => handleClickView(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Eye size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.edit && (
            <IconButton
              onClick={() => handleClickEdit(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Edit3 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.delete && (
            <IconButton
              onClick={() => handleClickOpen(params.row.id)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
              }}
              size="small" // Decrease the button size
            >
              <Trash2 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
        </>
      ),
    },
  ];

  // Define status colors for the dot indicator
  const statusColors = {
    view: 'green',
    delete: 'red',
  };

  // const handleDelete = () => {
  //   const toast = Toastmessage('deleted successfully', true)
  //   setRows((prevRows) => prevRows.filter((row) => row.id !== deleteLocation));
  //   setOpen(false);
  // };

  const handleDelete = async () => {

    const fetchData = async () => {
      const input_token = roleId + 'DELETE_ROLE';; // Replace with your actual token
      const apiUrl = 'delete_role'; // Replace with the actual API endpoint

      const dataInput = {
        id: roleId,
        login_user_id: userID
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setOpen(false);
          await fetchRole(); // Refresh the list after deletion
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    }

    // Call the function to make the API call
    await fetchData();
  };

  const handleClickOpen = (id) => {
    setOpen(true);
    setRoleId(id)
  };

  const handleClose = () => {
    setOpen(false);
  };

   // Updated handleSearch function
   const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);

    // Search all fields in rows
    const filteredData = rows.filter((row) =>
      Object.values(row).some((field) =>
        String(field).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filteredData); // Update filtered rows
  };
  
  const clearSearch = () => {
    setSearchText("");
    setFilteredRows(rows);
  };


  // Updated fetchRole function
  const fetchRole = async () => {
    const input_token = 'ROLES'; // Replace with your actual token
    const apiUrl = 'list_of_roles'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setRows(data.data); // Set the fetched roles to rows (original data)
        setFilteredRows(data.data); // Also set it to filteredRows (displayed data)
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
        className="title_head"
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="var(--text-color)">
            User Role List
          </Typography>
        </Box>

        {/* Right Section */}
        <Button
          variant="outlined"
          component={Link}
          to="/addRole"
          sx={{
            backgroundColor: 'var(--back-button)',
            color: "var(--back-color)",
            fontWeight: 'bold',
            border: 'none',
            padding: '10px 20px'
          }}
          startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
          style={{ textTransform: 'none' }}
        >
          Add New Role
        </Button>
      </Box>


      {/* <Box className="location-container">
        <Grid container className="d-block">
          <Grid className='top-header-box' iteme xs={12} sx={{ mb: 2, textAlign: "right" }}>
            <Button
              component={Link}
              to="/addRoll"
              variant="contained"
              startIcon={<PlusCircle size={20} />}
              sx={{ padding: '15px 30px', borderRadius: "8px", backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}
            >
              Add New Roll
            </Button>
          </Grid>
        </Grid> */}

      <Box m={3}>

        <Box className="location-header ">
          <h2>Total Role {filteredRows.length}</h2>
          <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              className="search-input"
              fullWidth
              InputProps={{
                endAdornment: searchText && (
                  <span
                    onClick={() => clearSearch()}
                    style={{
                      cursor: 'pointer',
                      color: '#aaa',
                      marginRight: '10px',
                    }}
                  >
                    ✕
                  </span>
                ),
              }}
            />
          </Box>
        </Box>
        <div sx={{ m: 0, p: 0 }}>
          <Box sx={{ width: '100%', display: 'flex' }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={5}
              autoHeight
              pagination
              disableSelectionOnClick
              rowsPerPageOptions={[]}
              className="data-grid"
              sx={{ width: '100%' }} // Ensure DataGrid takes full width
            />
          </Box>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this User Role?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleDelete} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>

  );
}
